import dayjs from 'dayjs';

export type DateRangePreset = '7d' | '1m' | '30d' | '2m' | '3m';

interface DateRangePresetConfig {
  key: DateRangePreset;
  label: string;
  getStart: () => dayjs.Dayjs;
}

export const DATE_RANGE_PRESETS: DateRangePresetConfig[] = [
  { key: '7d', label: 'Last 7 days', getStart: () => dayjs().subtract(7, 'day').startOf('day') },
  { key: '1m', label: 'Last month', getStart: () => dayjs().subtract(1, 'month').startOf('day') },
  { key: '30d', label: 'Last 30 days', getStart: () => dayjs().subtract(30, 'day').startOf('day') },
  { key: '2m', label: 'Last 2 months', getStart: () => dayjs().subtract(2, 'month').startOf('day') },
  { key: '3m', label: 'Last 3 months', getStart: () => dayjs().subtract(3, 'month').startOf('day') },
];

export const isValidDateRangePreset = (value: string): value is DateRangePreset => {
  return DATE_RANGE_PRESETS.some((p) => p.key === value);
};

export const getPresetStartDate = (preset: DateRangePreset): string => {
  const config = DATE_RANGE_PRESETS.find((p) => p.key === preset);
  if (!config) {
    return dayjs().subtract(1, 'month').startOf('day').format('YYYY-MM-DD HH:mm:ss');
  }
  return config.getStart().format('YYYY-MM-DD HH:mm:ss');
};

export const detectDateRangePreset = (
  startDate: string,
  endDate: string,
): DateRangePreset | null => {
  const endDay = dayjs(endDate).format('YYYY-MM-DD');
  const todayDay = dayjs().format('YYYY-MM-DD');
  if (endDay !== todayDay) return null;

  const startDay = dayjs(startDate).format('YYYY-MM-DD');
  for (const preset of DATE_RANGE_PRESETS) {
    if (startDay === preset.getStart().format('YYYY-MM-DD')) {
      return preset.key;
    }
  }

  return null;
};

export const getDateRangePresetsForPicker = (): Array<{ label: string; value: [Date, Date] }> => {
  return DATE_RANGE_PRESETS.map((preset) => ({
    label: preset.label,
    value: [preset.getStart().toDate(), new Date()] as [Date, Date],
  }));
};
